

























































































































































































































































































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import BaseFormEdit from '../../models/base.form.edit';
import DonorService from '../../services/donor.service.js';
import Donor from '../../models/donorRelative';
import axios from 'axios';
import { EventBus } from '@/event-bus';
import Swal from 'sweetalert2';
import Constants from '@/constants';
import FileUploader from '@/components/FileUploader.vue';
import PrintInfectionsStatusModal from '@/pages/donors/PrintInfectionsStatusModal.vue';

@Component({
  components: {
    FileUploader,
    PrintInfectionsStatusModal,
  },
})
export default class Edit extends BaseFormEdit {
  public form: any = new Donor();
  public initStatus: any = 0;
  public files: any[] = [];
  public labs: any[] = [];
  public tcOrganiztions: any[] = [];
  public patients: any[] = [];
  public isDictionary: boolean = false;
  public isGridRecieved: boolean = true;
  public collectionCenters: any[] = [];
  public transfusiologists: any[] = [];
  public transfusiologistsOptions: any[] | null = [];
  public initTransfusiologist = false;
  public isShownInfectionsModal = false;
  public infectionsResult: any = {};

  public STATUS_SEARCH: number = 1;
  public STATUS_CT: number = 16;
  public STATUS_ACTIVATION: number = 12;
  public STATUS_READY: number = 13;
  public STATUS_COMPATIBILITY: number = 17;
  public STATUS_RDKM_REJECT: number = 5;
  public STATUS_REGISTER_REJECT: number = 4;
  public REJECT_STATUSES = [5, 4];

  get title() {
    return this.form.isNew ? this.$t('Добавление донора') + '' :
           this.$t('Родственный донор') + ` IDD ${this.form.idd || ''}`;
  }

  get hasIon() {
    return window.ion;
  }

  get isDisabledOperator() {
    return this.$auth.user().isRdkm || this.initStatus > this.STATUS_SEARCH;
  }

  get patientName() {
    const patient = this.patients.find(f => f.key === this.form.patientId);
    if (patient) {
      return patient.value.split('(')[0];
    }
    return '';
  }

  get ctDirectionUrl() {
    return `/DonorsRelative/ExportHlaTyping?donorid=${this.form.id}&userId=${this.$auth.user().id}&patientId=${this.form.patientId}&labId=${this.form.laboratoryId}`;
  }

  get isTransfusiologistInfoVisible() {
    return this.transfusiologistsOptions && this.transfusiologistsOptions.length > 0;
  }

  get gskTemplateUrl() {
    if (this.form.medicalExamination && this.form.collectionDate &&
      this.form.collectionMethodId) {
      const medicalExamination = this.form.medicalExamination instanceof Date ?
                                 this.form.medicalExamination.toJSON() :
                                 new Date(this.form.medicalExamination).toJSON();

      const collectionDate = this.form.collectionDate instanceof Date ? 
                             this.form.collectionDate.toJSON() : 
                             new Date(this.form.medicalExamination).toJSON();
      return `${Constants.baseUrl}/DonorsRelative/GskTemplateForm?donorid=${this.form.id}
              &userId=${this.$auth.user().id}&medicalExamination=${medicalExamination}
              &collectionDate=${collectionDate}&collectionMethodId=${this.form.collectionMethodId}
              &patientId=${this.form.patientId}`;
    } else {
      return null;
    }
  }

  get isActivationOrReady() {
    return [ this.STATUS_ACTIVATION, this.STATUS_READY ].indexOf(this.initStatus) >= 0;
  }

  get disableInStatusCT() {
    return this.$auth.user().isLr || this.initStatus > this.STATUS_SEARCH;
  }

  get isActivationVisible() {
    return this.$auth.user().isLr && this.isActivationOrReady;
  }

  get isPrintGskTemplateAccessible() {
    return this.initStatus === this.STATUS_ACTIVATION;
  }

  get isActivationDisabled() {
    return this.initStatus !== this.STATUS_ACTIVATION;
  }

  @Watch('isDataLoaded')
  public onIsDataLoadedChanged(val: string) {
    if (val) {
      this.initStatus = this.form.status;
    }
  }

  public onAddInfectionsResult() {
    // @ts-ignore
    this.$refs.uploader.fetchData(true);
    this.infectionsResult = JSON.parse(JSON.stringify(this.form.infectionsResult));
  }

  public generateGskTemplate() {
    let errors = '';
    const br = '</br><strong>';
    const strong = '</strong>';
    if (!this.form.medicalExamination) {
      errors += br + this.$t('Дата обследования и консультации донора') + strong;
    }
    if (!this.form.collectionDate) {
      errors += br + this.$t('Дата сбора клеток') + strong;
    }
    if (!this.form.collectionMethodId) {
      errors += br + this.$t('Метод сбора клеток') + strong;
    }

    // @ts-ignore
    this.highlightAllLabels(errors);

    if (errors.length !== 0) {
      // @ts-ignore
      Swal(this.$t('Предупреждение') + '',
           this.$t('Нельзя создать файл `Расписание заготовки ГСК` без указания') + `: ${errors}`,
           'warning');
    }
  }

  public created() {
    this.loadOrganizations();
    this.loadLabs();
    this.loadPatients(this.form.tcOrganizationId);
    DonorService.loadCollectionCenters(this);
  }

  public statusOrder(status) {
    return [ this.STATUS_SEARCH, this.STATUS_CT, this.STATUS_COMPATIBILITY,
             this.STATUS_ACTIVATION, this.STATUS_READY,
             this.STATUS_REGISTER_REJECT, this.STATUS_RDKM_REJECT ].indexOf(status);
  }

  public getStatusByKey(key: number) {
    return this.form.statuses.find((x: any) => x.key === key);
  }

  public async onStatusChanged(status: any) {
    if (this.form.status === status) {
      return;
    }
    if (this.statusOrder(this.form.status) > this.statusOrder(status)) {
      const newStatusName = this.form.statuses.filter(s => s.key === status)[0].value;
      const msgText = Constants.RevertStatusMessageTemplate.replace('#status#', newStatusName);
      const msgHtml = document.createElement('div');
      msgHtml.innerHTML = msgText;
      const self = this;
      this.confirm(msgHtml, () => {
        self.saveStatus(status);
      });
    } else {
      this.saveStatus(status);
    }
  }

  public async saveStatus(status) {
    const statusPair = this.getStatusByKey(status);
    const oldStatus = this.form.status;
    this.form.status = statusPair.key;
    await this.submit('/donorsRelative', false, '', null, this.showStatusChangeError);
    if (this.isStatusChangeError) {
      this.form.status = oldStatus;
    }
  }

  public loadLabs() {
    axios.get('/SendDonorsToLr').then((response) => {
      this.labs = response.data.labarotories;
    });
  }

  public loadOrganizations() {
    axios.get('/Dictionary/GetTcOrganizationCodes').then((response) => {
      this.tcOrganiztions = response.data;
    });
  }

  @Watch('form.tcOrganizationId')
  public loadPatients(tcOrganizationId: any) {
    const self = this;
    const org = this.tcOrganiztions.find((f: any) => f.key === tcOrganizationId);
    this.form.tcCode = org ? org.value : '';
    axios.get('/Dictionary/GetRelativePatients?organizationId=' + tcOrganizationId).then((response) => {
      self.patients = response.data;
      const patient = self.patients.find((f: any) => f.key === self.form.patientId);
      if (!patient) {
        self.form.patientId = '';
      }
    });
  }

  @Watch('form.patientId')
  public patientChanged(patientId: any) {
    const patient = this.patients.find((f: any) => f.key === patientId);
    this.form.patientName = patient ? patient.value : '';
  }

  @Watch('form.operatorId')
  public onOperatorIdChanged(val: string, oldVal: string) {
    const operator: any = this.form.operatorsData.find((column: any) => column.id === val);
    if (operator) {
      this.form.operatorName = operator.name;
      this.form.operatorEmail = operator.email;
      // @ts-ignore
      this.$refs.operatorPhone.clearPhone();
      // @ts-ignore
      this.$refs.operatorAdphone.clearPhone();
      this.form.operatorPhone = operator.phone;
      this.form.operatorAdphone = operator.additionalPhone;
    }
  }

  @Watch('form.collectionCenterId')
  public onCollectionCenterIdChanged(val: any, oldVal: any) {
    const colCenter = this.collectionCenters.find((x: any) => x.key === val);
    this.form.collectionCenterName = colCenter != null ? colCenter.value : '';
    this.transfusiologists = this.form.transfusiologists.filter((column: any) => column.organizationId === val);
    let transfusiologist;
    if (this.transfusiologists && this.transfusiologists.length > 0) {
      if (this.transfusiologists.length > 1) {
        this.transfusiologistsOptions = this.transfusiologists.map((x: any) => ({ key: x.id, value: x.name }));
      }
      transfusiologist = this.transfusiologists.find(t => t.id === this.form.transfusiologistId) || 
                         this.transfusiologists.find(() => true);
    } else {
      this.transfusiologistsOptions = null;
    }
    this.updateTransfusiologistFields(transfusiologist);
  }

  public onChangeTransfusiologist(val: any) {
    const transfusiologist = this.transfusiologists.find(t => t.id === val);
    this.updateTransfusiologistFields(transfusiologist);
  }

  public updateTransfusiologistFields(transfusiologist: any) {
    this.form.transfusiologistId = (transfusiologist && transfusiologist.id) || '';
    if (this.initTransfusiologist) {
      this.form.transfusiologistName = (transfusiologist && transfusiologist.name) || '';
      this.form.transfusiologistEmail = (transfusiologist && transfusiologist.email) || '';
      // @ts-ignore
      this.$refs.transfusiologistPhone.clearPhone();
      // @ts-ignore
      this.$refs.transfusiologistAdphone.clearPhone();
      this.form.transfusiologistPhone = (transfusiologist && transfusiologist.phone) || '';
      this.form.transfusiologistAdphone = (transfusiologist && transfusiologist.additionalPhone) || '';
    }
    this.initTransfusiologist = true;
  }

  public onFilesUpdated(files: any) {
    this.files = files;
    const fileType = this.$t('Согласие донора на донацию');
    // @ts-ignore
    // this.$refs.ctFileInfo.clearFiles();
    this.form.ctFileInfo = files.find((t: any) => t.fileTypeName === fileType);
  }

  public onRemoveFile(fileTypeName: any, nextFielInfo: any) {
    if (fileTypeName === 'Согласие донора на донацию') {
      // @ts-ignore
      // this.$refs.ctFileInfo.clearFiles();
      this.form.ctFileInfo = nextFielInfo;
    }
  }

  public donorNumberFormatter(n: any) {
    return String(n).substring(0, 13);
  }

  @Watch('form.externalId')
  public onExternalIdChange() {
    if (this.isDataLoaded && this.form.isNew) {
      EventBus.$emit('showThrobber');
      const url = `/Donors/GetGridFromExternalId?externalId=${this.form.externalId}&organizationId=`
                + this.$auth.user().currentOrganization.id;

      axios.get(url).then((response: any) => {
        this.form.grid = response.data.grid;
        this.isGridRecieved = true;
      }).catch(() => {
        EventBus.$emit('error', { msg: this.$t('Ошибка получения `Код донора GRID` с сервера') });
        this.isGridRecieved = false;
      }).finally(() => {
        EventBus.$emit('hideThrobber');
      });
    }
  }

  protected onFetchDataFinish() {
    if (!this.form.operatorId && this.form.operatorsData.length > 0) {
      const currentUserId = this.$auth.user().id;
      if (this.form.operatorsData.filter((column: any) => column.id === currentUserId).length > 0) {
        this.form.operatorId = currentUserId;
      } else {
        this.form.operatorId = this.form.operatorsData[0].id;
      }
    }
    this.infectionsResult = JSON.parse(JSON.stringify(this.form.infectionsResult));
  }
}
